import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  mainWrapper: { flex: 1 },
  inputContainer: {
    width: 542,
    paddingLeft: 16,
    paddingRight: 19,
    backgroundColor: '#F7F9FC',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E4E9F2',
    textAlignVertical: 'top',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 31,
    marginLeft: -24,
  },
  input: {
    width: 680,
    marginTop: 0,
    backgroundColor: '#F7F9FC',
    borderWidth: 1,
    borderColor: '#E4E9F2',
  },
  rowsLabel: {
    fontWeight: '500',
    fontSize: 14,
    color: '#003353',
    lineHeight: 20,
  },
  businessNameLabel: {
    fontSize: 16,
    color: '#335C75',
    lineHeight: 24,
  },
})
